import { capi } from "..";
import { GetMortgageDataDTOin } from "./DTOs/getMortgageDataDTOin";
import { GetMortgageDataDTOout } from "./DTOs/getMortgageDataDTOout";

export const getMortgageData = (getMortgageDataDTOin: GetMortgageDataDTOin): Promise<GetMortgageDataDTOout> => {
    return capi.get(`/v1/mortgages/data/get/${getMortgageDataDTOin.mortgage}`);
}